<main class="edenred-one-header align-items-center">
   <a href="{{ externalUrl }}" target="_blank" class="edenred-one-header__container d-flex align-items-center gap-2">
     <img src="/assets/img/ico-back-full.svg" alt="Logo Edenred One" class="edenred-one-header__container__logo"/>
     <div class="edenred-one-header__container__description d-flex flex-column">
       <span>Voltar para o</span>
       <span class="font-weight-bold">Edenred One</span>
     </div>
   </a>
</main>
